export const state = () => ({
    config: {
        
        linkArr:[
            
        ],
        
    }
})

export const mutations = {
    
}
